import { html, TemplateResult } from "lit-html";
import { ifDefined } from "lit-html/directives/if-defined";
import { live } from "lit-html/directives/live";

const InputComponent = ({
  id,
  type,
  name,
  value,
  cssClasses,
  placeholder,
  eventHandlers,
  options
}: IInputElement): TemplateResult => {
  return html`
    <input
      id=${ifDefined(id)}
      type=${type}
      name=${ifDefined(name)}
      class=${ifDefined(cssClasses)}
      placeholder=${ifDefined(placeholder)}
      .value=${ifDefined(live(value))}
      tabindex=${ifDefined(options?.tabIndex)}
      autocomplete=${ifDefined(options?.autoComplete)}
      pattern=${ifDefined(options?.pattern)}
      aria-hidden=${ifDefined(options?.ariaHidden)}
      ?autofocus=${options?.autofocus}
      ?disabled=${options?.disabled}
      ?readonly=${options?.readOnly}
      ?required=${options?.required}
      @input=${eventHandlers?.onInput}
      @keydown=${eventHandlers?.onKeyDown}
      @blur=${eventHandlers?.onBlur}
      @change=${eventHandlers?.onChange}
    >
    `;
}

export default InputComponent;